export default {"src":"/_next/static/media/Assignment.68ed5fbf.svg","height":60,"width":54,"blurWidth":0,"blurHeight":0};